// NotifyMemu.tsx
import {
  Link,
  useFetcher,
  useRouteLoaderData,
} from "@remix-run/react";
import clsx from "clsx";
import React, {
  useEffect,
  useState,
} from "react";
import type { loader } from "../../root";
import UserIcon from "./UserIcon";
import { m } from "framer-motion";
import type { NotifyType } from "~/database/notifications.model";

interface NotifyMemuProps {
  menuRef: React.RefObject<HTMLDivElement>;
}

const listCLass = clsx(
  "flex",
  "flex-col",
  "divide-y-[1px]",
);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _sampleNotifyData = [
  {
    id: "b0a6c933-c2b3-4d68-83f1-03fea6224c71",
    type: "comment",
    user_id:
      "3f750ba5-0a10-4176-9bea-d69c9c0d3292",
    like_id: null,
    is_read: false,
    comment_id:
      "4aea2879-5ba5-4286-9067-db85e87194c1",
    follows_id: null,
    likes: null,
    comments: {
      id: "4aea2879-5ba5-4286-9067-db85e87194c1",
      user_id:
        "e83c00b2-b4e2-4482-b50e-6b306793ece5",
      post_id:
        "753e123e-146d-4836-8ed1-0eb33f908644",
      created_at:
        "2025-01-17T14:59:24.736108+00:00",
      updated_at:
        "2025-01-17T14:59:24.736108+00:00",
      content: "TEST_COMMENT",
      posts: {
        id: "1",
        title: "test",
      } as any,
      public_users: {
        id: "1",
        name: "test",
        iconurl: "",
      } as any,
    },
    follows: null,
  },
  {
    id: "c4fd857e-8fc4-4d06-96e3-979d7a400c8d",
    type: "followed",
    user_id:
      "3f750ba5-0a10-4176-9bea-d69c9c0d3292",
    like_id: null,
    is_read: false,
    comment_id: null,
    follows_id:
      "7ce87ea4-7af0-4de2-bfd0-b9d0c5ec7fa5",
    likes: null,
    comments: null,
    follows: {
      public_users: {
        id: "1",
        name: "test",
        iconurl: "",
      } as any,
    },
  },

  {
    type: "like",
    id: "1",
    is_read: true,
    likes: {
      posts: {
        id: "1",
        title: "test",
      } as any,
      public_users: {
        id: "1",
        name: "test",
        iconurl: "",
      } as any,
    },
  },
  {
    type: "like",
    id: "1",
    is_read: true,
    likes: {
      posts: {
        id: "1",
        title: "test",
      } as any,
      public_users: {
        id: "1",
        name: "test",
        iconurl: "",
      } as any,
    },
  },
  {
    type: "like",
    id: "1",
    is_read: true,
    likes: {
      posts: {
        id: "1",
        title: "test",
      } as any,
      public_users: {
        id: "1",
        name: "test",
        iconurl: "",
      } as any,
    },
  },
  {
    type: "like",
    id: "1",
    is_read: true,
    likes: {
      posts: {
        id: "1",
        title: "test",
      } as any,
      public_users: {
        id: "1",
        name: "test",
        iconurl: "",
      } as any,
    },
  },
  {
    type: "like",
    id: "1",
    is_read: true,
    likes: {
      posts: {
        id: "1",
        title: "test",
      } as any,
      public_users: {
        id: "1",
        name: "test",
        iconurl: "",
      } as any,
    },
  },
] as NotifyType[];

const SAMPLE_DISPLAY_COUNT = false;
const NotifyMemu: React.FC<NotifyMemuProps> = ({
  menuRef,
}) => {
  const root =
    useRouteLoaderData<typeof loader>("root");
  const userData = root?.userData;
  const notifyData = root?.notificationData;
  //const notifyData = sampleNotifyData;
  const [readNotifyIds, setReadNotifyIds] =
    useState<string[]>([]);
  // 既読 = readNotifyIds.include

  const fetcher = useFetcher();

  useEffect(() => {
    if (userData?.id) {
      setReadNotifyIds(
        notifyData
          ?.filter((el) => el.is_read)
          .map((el) => el.id) ?? [],
      );
      fetcher.submit(
        {},
        {
          method: "post",
          action: `/notify`,
        },
      );
    }
    //初回のみ
    // 追加変更時にも既読は増えない
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <m.div
      exit={{ opacity: 0 }}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      ref={menuRef}
      className={clsx(
        "absolute",
        "right-0",
        "top-0",
        "z-30",
        "shadow-lg",
        "bg-white",
        "max-h-300",
        "w-240",
        "overflow-auto",
        "border",
        "rounded-[10px]",
      )}
    >
      <div
        className={clsx(
          "text-center",
          "font-bold",
          "py-10",
          "border-b-[1px]",
          "border-gray-200",
          "text-12",
        )}
      >
        通知
      </div>
      <div className={clsx("text-left")}>
        {((notifyData && notifyData.length > 0) ||
          SAMPLE_DISPLAY_COUNT) && (
          <ul className={clsx(listCLass)}>
            {(SAMPLE_DISPLAY_COUNT
              ? _sampleNotifyData
              : notifyData!
            ).map((el, i) => {
              return el.type === "like" ? (
                <li
                  key={i}
                  className={clsx(
                    !readNotifyIds.includes(
                      el.id,
                    ) && "bg-blue-100",
                    "px-15",
                    "py-10",
                    "w-full",
                  )}
                >
                  <h3
                    className={clsx(
                      "text-12",
                      "font-bold",
                    )}
                  >
                    いいねされました！
                  </h3>
                  <h4
                    className={clsx(
                      "text-12",
                      "text-gray-400",
                      "mt-3",
                    )}
                  >
                    <Link
                      to={`/posts/${el?.likes.posts.display_id}`}
                      className={clsx(
                        "underline",
                      )}
                    >
                      {el?.likes.posts.title}
                    </Link>
                    <div
                      className={clsx(
                        "text-10",
                        "flex",
                        "items-center",
                        "gap-10",
                      )}
                    >
                      from:
                      <Link
                        to={`/user/${el?.likes.public_users.id}`}
                        className={clsx(
                          "text-10",
                          "flex",
                          "items-center",
                          "gap-3",
                        )}
                      >
                        <div
                          className={clsx(
                            "w-24",
                            "h-24",
                            "mx-auto",
                          )}
                        >
                          <UserIcon
                            iconPath={
                              el?.likes
                                .public_users
                                .iconurl ?? ""
                            }
                          />
                        </div>
                        {
                          el?.likes.public_users
                            .name
                        }
                      </Link>
                    </div>
                  </h4>
                </li>
              ) : el.type === "followed" ? (
                <div className={clsx()}>
                  <li
                    key={i}
                    className={clsx(
                      !readNotifyIds.includes(
                        el.id,
                      ) && "bg-blue-100",
                      "px-15",
                      "py-10",
                      "w-full",
                    )}
                  >
                    <h3
                      className={clsx(
                        "text-12",
                        "font-bold",
                      )}
                    >
                      フォローされました！
                    </h3>
                    <h4
                      className={clsx(
                        "text-12",
                        "text-gray-400",
                        "mt-3",
                      )}
                    >
                      <div
                        className={clsx(
                          "text-10",
                          "flex",
                          "items-center",
                          "gap-10",
                        )}
                      >
                        from:
                        <Link
                          to={`/user/${el?.follows?.public_users.id}`}
                          className={clsx(
                            "text-10",
                            "flex",
                            "items-center",
                            "gap-3",
                          )}
                        >
                          <div
                            className={clsx(
                              "w-24",
                              "h-24",
                              "mx-auto",
                            )}
                          >
                            <UserIcon
                              iconPath={
                                el?.follows
                                  ?.public_users
                                  .iconurl ?? ""
                              }
                            />
                          </div>
                          {
                            el?.follows
                              ?.public_users.name
                          }
                        </Link>
                      </div>
                    </h4>
                  </li>
                </div>
              ) : (
                <li
                  key={i}
                  className={clsx(
                    !readNotifyIds.includes(
                      el.id,
                    ) && "bg-blue-100",
                    "px-15",
                    "py-10",
                    "w-full",
                  )}
                >
                  <h3
                    className={clsx(
                      "text-12",
                      "font-bold",
                    )}
                  >
                    コメントがつきました！
                  </h3>
                  <h4
                    className={clsx(
                      "text-12",
                      "text-gray-400",
                      "mt-3",
                      "w-full",
                    )}
                  >
                    <div
                      className={clsx(
                        "text-10",
                        "line-clamp-2",
                      )}
                    >
                      {el?.comments?.content}
                    </div>
                    <Link
                      to={`/posts/${el?.comments?.posts.display_id}`}
                      className={clsx(
                        "underline",
                      )}
                    >
                      {el?.comments?.posts.title}
                    </Link>
                    <div
                      className={clsx(
                        "text-10",
                        "flex",
                        "items-center",
                        "gap-10",
                      )}
                    >
                      from:
                      <Link
                        to={`/user/${el?.comments?.public_users.id}`}
                        className={clsx(
                          "text-10",
                          "flex",
                          "items-center",
                          "gap-3",
                        )}
                      >
                        <div
                          className={clsx(
                            "w-24",
                            "h-24",
                            "mx-auto",
                          )}
                        >
                          <UserIcon
                            iconPath={
                              el?.comments
                                ?.public_users
                                .iconurl ?? ""
                            }
                          />
                        </div>
                        {
                          el?.comments
                            ?.public_users.name
                        }
                      </Link>
                    </div>
                  </h4>
                </li>
              );
            })}
          </ul>
        )}
        {!(
          notifyData && notifyData.length > 0
        ) && (
          <div
            className={clsx(
              "h-270",
              "flex",
              "items-center",
              "justify-center",
              "text-15",
              "text-gray-400",
            )}
          >
            お知らせがありません。
          </div>
        )}
      </div>
    </m.div>
  );
};

export default NotifyMemu;
